import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './outline-iframe.css.lit';

/**
 * The OutlineIframe component
 * @element outline-iframe
 */
@customElement('outline-iframe')
export class OutlineIframe extends OutlineElement {
  static styles = [componentStyles];

  slots = new SlotsController(this);

  @property({ type: Boolean, reflect: true, attribute: 'is-bordered' })
  isBordered = false;

  render(): TemplateResult {
    return html`
      <div
        class=${classMap({
          'outline-iframe-wrapper': true,
          'outline-iframe-wrapper--bordered': this.isBordered,
        })}
      >
        ${this.slots.conditionalSlot('iframe', false)}
      </div>
    `;
  }
}
